export const PUBLIC_SITE_URL =
  import.meta.env.VITE_PUBLIC_SITE_URL || "https://duriapp.com";

/** Default Open Graph / Twitter card image (absolute URL). */
export const DEFAULT_OG_IMAGE = `${PUBLIC_SITE_URL}/Logo_Duri.png`;
